import { ResourceFile } from './Shared/DomainValidationFunctions';

export const abnMustBeValid: string = 'Please enter a valid ABN';
export const emailAddressMustBeValid: string = 'Please enter a valid email address';
export const invalidEmailMessage = 'Invalid email address';
export const timeZoneIsRequired: string = 'Please select a time zone';
export const noRecordsFound: string = 'Whoops! We could not find any records.';
export const requiredField = 'Required';
export const invalidField = 'Invalid';
export const minimumOneItem: string = 'Must have at least 1 item.';
export const sexIsRequired: string = 'Please enter a sex.';
export const familyNameIsRequired: string = 'Please enter a family name.';
export const givenNameIsRequired: string = 'Please enter a given name.';
export const invalidDate = 'Invalid date';
export const invalidYear = 'Year is invalid';
export const dateIsInTheFuture = 'Date is in the future';
export const yearIsInTheFuture = 'Year is in the future';
export const beforeStartDate = 'Before Start date';
export const afterExpiryDate = 'After Expiry date';
export const formErrorMessage = 'Please correct highlighted errors';

export const AuthorisationLocale: ResourceFile = {};
